import union from 'lodash.union';
import { uiComponents, uiStates, viewIsOpen } from '../tools/viewState';
import { getterTypes } from '@/types/index';
import { logger } from '../tools';
import { mutuallyExclusiveComponentsList } from '@/tools/viewState';

export default {
	[getterTypes.globalConfig](state) {
		return state.dataSourceCFG ? state.dataSourceCFG.global : {};
	},

	// Language Related

	[getterTypes.i18Notifyer](state) {
		return () => state.persistent.language;
	},
	[getterTypes.currentLanguage](state) {
		return state.persistent.language;
	},
	[getterTypes.currentDefaultLanguage](state) {
		return (
			state.dataSourceCFG &&
			state.dataSourceCFG.exhibitionMap[state.currentExhibitionID] &&
			state.dataSourceCFG.exhibitionMap[state.currentExhibitionID].defaultLanguage
		);
	},
	[getterTypes.possibleLanguages](state) {
		return state.dataSourceCFG && state.dataSourceCFG.exhibitions
			? union(...state.dataSourceCFG.exhibitions.map(ex => ex.languages))
			: [];
	},

	// values dependend by router
	[getterTypes.currentExhibition](state) {
		return (
			state.dataSourceCFG &&
			state.currentExhibitionID &&
			state.dataSourceCFG.exhibitionMap[state.currentExhibitionID]
		);
	},
	[getterTypes.exhibitions](state) {
		if (!state.dataSourceCFG) return [];
		return state.dataSourceCFG.exhibitions;
	},
	[getterTypes.getExhibition](state) {
		return exhibitionID => state.dataSourceCFG.exhibitionMap[exhibitionID];
	},
	[getterTypes.currentArticle](state) {
		if (!state.dataSourceCFG || !state.currentExhibitionID || !state.currentArticleID) return;

		const currentExhibition = state.dataSourceCFG.exhibitionMap[state.currentExhibitionID];
		if (!currentExhibition) return;

		const article = currentExhibition.articleMap[state.currentArticleID];
		return article;
	},
	[getterTypes.currentArticleContent](state, getters) {
		if (!state.articleContent[state.currentArticleID]) {
			logger.log(
				`Could not find article ${state.currentArticleID} content in language ${getters.currentLanguage} `
			);
			return '';
		}
		return (
			(state.articleContent[state.currentArticleID] &&
				state.articleContent[state.currentArticleID][getters.currentLanguage]) ||
			''
		);
	},
	[getterTypes.currentGlossaryContent](state, getters) {
		if (!state.articleContent[state.currentGlossaryTermID]) {
			logger.log(
				`Could not find glossary term ${state.currentGlossaryTermID} content in language ${getters.currentLanguage} `
			);
			return '';
		}
		return state.articleContent[state.currentGlossaryTermID][getters.currentLanguage] || '';
	},
	[getterTypes.currentCalendarEventContent](state, getters) {
		if (!state.articleContent[state.currentCalendarEventID]) {
			logger.log(
				`Could not find glossary term ${state.currentCalendarEventID} content in language ${getters.currentLanguage} `
			);
			return '';
		}
		return state.articleContent[state.currentCalendarEventID][getters.currentLanguage] || 'EVENT MISSING';
	},

	// BeaconStufff
	[getterTypes.beaconSettings](state) {
		return state.dataSourceCFG ? state.dataSourceCFG.global.beaconSettings : {};
	},
	[getterTypes.currentBeacons](state) {
		if (state.dataSourceCFG && state.dataSourceCFG.exhibitions) {
			const tmp = state.dataSourceCFG.exhibitions.find(ex => ex.exhibitionID == state.currentExhibitionID);
			return tmp ? tmp.beacons : undefined;
		}
		return undefined;
	},
	[getterTypes.variableStorage](state) {
		return state.dataSourceCFG ? state.dataSourceCFG.variableStorage : [];
	},
	[getterTypes.viewStateString](state) {
		return Object.values(state.viewState)
			.filter(uiComponent => uiComponent.uiState !== uiStates.hidden)
			.map(uiComponent =>
				uiComponent.uiState === uiStates.maximised
					? `.${uiComponent.name},`
					: `.${uiComponent.name}--minimized,`
			)
			.join('');
	},
	// map, search, etc are shown and article content should be hidden
	[getterTypes.mainContentObscured](state) {
		return viewIsOpen(state, uiComponents.uiMap);
	},

	[getterTypes.articleCodeMap](state) {
		if (state.dataSourceCFG) {
			if (state.dataSourceCFG.configWebClient.keyPad.combineCodeMaps) {
				return state.dataSourceCFG.exhibitions.reduce((acc, exhibition) => {
					return Object.assign(acc, exhibition.codeMap);
				}, {});
			} else {
				return state.dataSourceCFG.exhibitionMap[state.currentExhibitionID].codeMap || {};
			}
		}
		return {};
	},

	[getterTypes.viewStateAriaHideMainElements](state) {
		return mutuallyExclusiveComponentsList.reduce((acc, entry) => {
			return state.viewState[entry].uiState !== uiStates.hidden ? true || acc : acc;
		}, false);
	},
};
